/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// Utils
import { get } from 'lodash';

// Components
import Badge from 'shared/ui/components/Badge.vue';
import ExpandableContent from 'shared/ui/components/ExpandableContent.vue';


const __vue_script__ = {
    name: 'Accordion',

    components: {
        Badge,
        ExpandableContent
    },

    props: {
        headersI18nPrefix: {
            type: String,
            default: ''
        },

        defaultOpenItem: {
            type: String,
            default: null
        },

        unlimitedHeight: {
            type: Boolean,
            default: false
        },

        options: {
            type: Object,
            default: () => ({})
        },

        animated: {
            type: Boolean,
            default: false
        },

        slim: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            openItem: this.defaultOpenItem ? this.defaultOpenItem : Object.keys(this.$scopedSlots)[0]
        };
    },

    computed: {
        headerI18nCodes() {
            const i18nCodes = {};
            for (const slotName of Object.keys(this.$scopedSlots)) {
                i18nCodes[slotName] = `${this.headersI18nPrefix}.${slotName}`;
            }

            return i18nCodes;
        }
    },

    methods: {
        /**
         * Sets the name of the current open accordion
         *
         * @param {string} accordion The name of the accordion to be opened
         * @param {boolean} open whether the given item is open or not
         */
        changeOpenItem(accordion, open) {
            this.openItem = open ? accordion : null;
        },

        slotIcon(slotName) {
            return get(this.options, `${slotName}.icon`);
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"accordion"},[_vm._l((Object.keys(_vm.$scopedSlots)),function(slotName){
var _obj;
return [_c('expandable-content',{staticClass:"accordion-item",class:( _obj = { 'with-header-icon': _vm.slotIcon(slotName) }, _obj[slotName] = slotName, _obj ),attrs:{"clickable-header":true,"slim":_vm.slim,"is-open":_vm.openItem === slotName,"unlimited-height":_vm.unlimitedHeight,"toggler-text":_vm.options.togglerText,"animated":_vm.animated},on:{"toggle":function (open) { return _vm.changeOpenItem(slotName, open); }},scopedSlots:_vm._u([(!_vm.slotIcon(slotName))?{key:"header",fn:function(){return [_c('span',[_vm._v(_vm._s(_vm.$t(_vm.headerI18nCodes[slotName])))]),(_vm.options[slotName] && _vm.options[slotName].badge)?_c('badge',[_vm._v(_vm._s(_vm.$t((_vm.headersI18nPrefix + "." + (_vm.options[slotName].badge)))))]):_vm._e()]},proxy:true}:{key:"header",fn:function(){return [_c('div',{staticClass:"header-icon"},[_c('i',{class:_vm.options[slotName].icon})]),_c('div',{staticClass:"header-text"},[_c('span',[_vm._v(_vm._s(_vm.$t(_vm.headerI18nCodes[slotName])))])])]},proxy:true}],null,true)},[_vm._t(slotName)],2)]})],2)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "Accordion.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__